



























import { Component, Vue } from 'vue-property-decorator';


@Component({
  name: 'NewRegisterSuccess'
})

export default class NewRegisterSuccess extends Vue {
  created() {
    document.title = '俏租机';
  }
}
